<template>
  <div>
    <a-select v-model="rnaType" placeholder="Select data list" size="large" style="width: 400px;margin-left: 10px;">
      <a-select-option value="mRNA">
        mRNA
      </a-select-option>
      <a-select-option value="lncRNA">
        lncRNA
      </a-select-option>
      <a-select-option value="circRNA">
        circRNA
      </a-select-option>
    </a-select>
    <a-tabs v-if="rnaType==='mRNA'" class="parent-tabs" default-active-key="1" type="card" size="large" style="margin: 20px 10px 0px 10px;height: 640px;">
      <a-tab-pane key="1" tab="Differential expression" style="margin-top: 10px;">
        <differential-expression></differential-expression>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Single gene expression" style="margin-top: 10px;">
        <single-gene-expression></single-gene-expression>
      </a-tab-pane>
      <a-tab-pane key="3" tab="GO_KEGG" style="margin-top: 10px;">
        <go-kegg></go-kegg>
      </a-tab-pane>
      <a-tab-pane key="5" tab="GSEA" style="margin-top: 10px;">
        <gsea-analysis></gsea-analysis>
      </a-tab-pane>
      <a-tab-pane key="6" tab="PPI network" style="margin-top: 10px;">
        <protein-protein></protein-protein>
      </a-tab-pane>
    </a-tabs>
    <a-tabs v-else-if="rnaType==='lncRNA'" class="parent-tabs" default-active-key="1" type="card" size="large" style="margin: 20px 10px 0px 10px;height: 640px;">
      <a-tab-pane key="1" tab="Differential expression" style="margin-top: 10px;">
        <inc-rna-differential-expression></inc-rna-differential-expression>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Single gene expression" style="margin-top: 10px;">
        <inc-rna-single-gene-expression></inc-rna-single-gene-expression>
      </a-tab-pane>
      <a-tab-pane key="6" tab="Query incRNA infomation">
        <inc-rna-query-rna-infomation></inc-rna-query-rna-infomation>
      </a-tab-pane>
      <a-tab-pane key="3" tab="GO_KEGG" style="margin-top: 10px;">
        <inc-rna-go-kegg></inc-rna-go-kegg>
      </a-tab-pane>
      <a-tab-pane key="5" tab="GSEA" style="margin-top: 10px;">
        <inc-rna-gsea-analysis></inc-rna-gsea-analysis>
      </a-tab-pane>
    </a-tabs>
    <a-tabs v-else-if="rnaType==='circRNA'" class="parent-tabs" default-active-key="1" type="card" size="large" style="margin: 20px 10px 0px 10px;height: 640px;">
      <a-tab-pane key="1" tab="Differential expression" style="margin-top: 10px;">
        <circ-rna-differential-expression></circ-rna-differential-expression>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Single gene expression" style="margin-top: 10px;">
        <circ-rna-single-gene-expression></circ-rna-single-gene-expression>
      </a-tab-pane>
      <a-tab-pane key="6" tab="Query circRNA infomation">
        <circ-rna-query-rna-infomation></circ-rna-query-rna-infomation>
      </a-tab-pane>
      <a-tab-pane key="3" tab="GO_KEGG" style="margin-top: 10px;">
        <circ-rna-go-kegg></circ-rna-go-kegg>
      </a-tab-pane>
      <a-tab-pane key="5" tab="GSEA" style="margin-top: 10px;">
        <circ-rna-gsea-analysis></circ-rna-gsea-analysis>
      </a-tab-pane>
    </a-tabs>
    <div v-else style="margin: 10px;height: 640px; font-size: 20px;font-weight: bold;">
      Coming soon.
    </div>
  </div>
</template>
  
<script>
import DifferentialExpression from '@/components/Analysis/DifferentialExpression.vue';
import SingleGeneExpression from '@/components/Analysis/SingleGeneExpression.vue';
import GoKegg from '@/components/Analysis/GoKegg.vue';
import GseaAnalysis from '@/components/Analysis/GseaAnalysis.vue';
import ProteinProtein from '@/components/Analysis/ProteinProtein.vue';
import CircRnaDifferentialExpression from '@/components/CircRnaAnalysis/CircRnaDifferentialExpression.vue';
import CircRnaSingleGeneExpression from '@/components/CircRnaAnalysis/CircRnaSingleGeneExpression.vue';
import CircRnaQueryRnaInfomation from '@/components/CircRnaAnalysis/CircRnaQueryRnaInfomation.vue';
import CircRnaGoKegg from '@/components/CircRnaAnalysis/CircRnaGoKegg.vue';
import CircRnaGseaAnalysis from '@/components/CircRnaAnalysis/CircRnaGseaAnalysis.vue';
import IncRnaDifferentialExpression from '@/components/IncRnaAnalysis/IncRnaDifferentialExpression.vue';
import IncRnaSingleGeneExpression from '@/components/IncRnaAnalysis/IncRnaSingleGeneExpression.vue';
import IncRnaQueryRnaInfomation from '@/components/IncRnaAnalysis/IncRnaQueryRnaInfomation.vue';
import IncRnaGoKegg from '@/components/IncRnaAnalysis/IncRnaGoKegg.vue';
import IncRnaGseaAnalysis from '@/components/IncRnaAnalysis/IncRnaGseaAnalysis.vue';

  export default {
    name: 'WholeTransAnalysis',
  components: {
    DifferentialExpression,
    SingleGeneExpression,
    GoKegg,
    GseaAnalysis,
    ProteinProtein,
    CircRnaDifferentialExpression,
    CircRnaQueryRnaInfomation,
    CircRnaSingleGeneExpression,
    CircRnaGoKegg,
    CircRnaGseaAnalysis,
    IncRnaDifferentialExpression,
    IncRnaQueryRnaInfomation,
    IncRnaSingleGeneExpression,
    IncRnaGoKegg,
    IncRnaGseaAnalysis,
  },
    data() {
    return {
      rnaType: 'mRNA'
    };
  },
    methods: {
    },
  };
  </script>
  
<style scoped>
.code-box-demo .ant-slider {
  margin-bottom: 16px;
}
</style>
